<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <div class="card" v-if="registrations">

                        <div class="card-header border-0">
                            <div class="row">
                                <div class="col-6">
                                    <h3 class="mb-0 text-uppercase">{{ cohort.name }}: {{ $t('reports.cohort-degrees') }}</h3>
                                </div>
                                <div class="col-6 text-right">
                                    <el-dropdown trigger="click" @command="openReport($event)">
                                        <base-button type="primary" class="dropdown-toggle btn-sm mr-0" @click.prevent.stop="">
                                            <i class="tim-icons icon-line-chart mr-1"></i> {{ $t('common.reports') }}
                                        </base-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item command="learners">
                                                {{ $t('reports.cohort-learners') }}
                                            </el-dropdown-item>
                                            <el-dropdown-item command="instructors">
                                                {{ $t('reports.cohort-instructors') }}
                                            </el-dropdown-item>
                                            <el-dropdown-item command="degrees">
                                                {{ $t('reports.cohort-degrees') }}
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </div>
                            </div>
                        </div>

                        <p class="card-body mt-2" v-if="empty">
                            <strong>{{ $t('dashboard.no-degree') }}</strong>
                        </p>

                        <div v-if="!empty">
                            
                            <el-table class="table-responsive table-flush"
                                    header-row-class-name="thead-light"
                                    :data="registrations">

                                <el-table-column min-width="130">
                                    <div slot="header">
                                        {{ $t('reports.progress') }}
                                    </div>
                                    <template v-slot="{row}">

                                        <h3 class="mb-2">
                                            {{ row.degree.name }}
                                        </h3>

                                        <base-progress type="info" :value="progress(row)">
                                        </base-progress>

                                        <span class="d-block">
                                            <strong>{{ progress(row) }}%</strong> {{ $t('dashboard.done').toLowerCase() }}
                                        </span>

                                    </template>
                                </el-table-column>

                                <el-table-column min-width="120">
                                    <div slot="header">
                                        {{ $t('reports.period') }}
                                    </div>
                                    <template v-slot="{row}">

                                        <span class="d-block mb-1" v-if="row.state.from">
                                            <i class="fas fa-calendar-alt mr-1"></i> {{ date(row.state.from) }}
                                            <br>to {{ date(row.state.to) }}
                                        </span>

                                        <badge type="secondary" v-if="row.status == 'archived'">
                                            {{ $t('status.archived') }}
                                        </badge>

                                    </template>
                                </el-table-column>

                                <el-table-column min-width="150">
                                    <div slot="header">
                                        {{ $t('reports.facts') }}
                                    </div>
                                    <template v-slot="{row}">
                                        <div v-if="hasData(row)">
                                            <small class="d-block">
                                                <i class="fas fa-user-friends mr-1"></i> <b>{{ row.state.learners.length + row.state.withdrawed_learners.length }}</b> {{ $t('reports.learners-with-data') }}
                                            </small>

                                            <small class="d-block" v-if="row.state.withdrawed_learners.length">
                                                <i class="fas fa-user-friends mr-1 text-muted"></i> <b>{{ row.state.withdrawed_learners.length }}</b> {{ $t('reports.have-been-withdrawed') }}
                                            </small>

                                            <small class="d-block">
                                                <i class="fas fa-pencil-alt mr-1"></i> <b>{{ row.state.instructors.length }}</b> {{ $t('reports.active-instructors') }}
                                            </small>

                                            <small class="d-block" v-if="row.state.remedial_sessions + row.state.withdrawed_remedial_sessions">
                                                <i class="fas fa-undo mr-1"></i> <b>{{ row.state.remedial_sessions + row.state.withdrawed_remedial_sessions }}</b> {{ $t('reports.remedial-sessions') }}
                                            </small>
                                        </div>
                                    </template>
                                </el-table-column>

                                <el-table-column align="center" class-name="competencies" width="180">
                                    <div slot="header">
                                        {{ $t('reports.competencies') }}
                                    </div>
                                    <template v-slot="{row}">
                                        <div v-if="hasData(row)">
                                            <ratings :data="row.state.competency_ratings"></ratings>
                                        </div>
                                    </template>
                                </el-table-column>

                                <el-table-column align="right" class-name="actions" min-width="128">
                                    <template v-slot="{row}">
                                        <div class="p-1" v-if="hasData(row)">

                                            <base-button type="primary" size="sm" class="d-inline-block mb-1 mr-0" @click="openResults(row)">
                                                <i class="tim-icons icon-line-chart mr-1"></i> {{ $t('reports.cohort-results') }}
                                            </base-button>

                                            <!--
                                            <base-button type="secondary" size="sm" class="d-inline-block" @click="openRegistration(row)"
                                                    v-if="canReadRegistration(row)">
                                                {{ $t('dashboard.follow-up') }}
                                            </base-button>
                                            -->
                                        </div>
                                    </template>
                                </el-table-column>
                                
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import Ratings from './charts/CompetencyRatings';

    export default {

        components: {
            Ratings,
        },

        data() {
            return {
                cohort: {},
                registrations: null,
                ratingOptions: null,
                moment: moment,
            }
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/astral/api/front/reports/cohorts/'+to.params.cohortId+'/registrations')
            .then(resp => {
                next(vm => {
                    vm.registrations = resp.data.data
                    vm.cohort = resp.data.included.cohort
                    vm.ratingOptions = resp.data.included.rating_options
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                }
            });
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('reports.cohorts'),
                        route: '/astral/ui/reports/cohorts'
                    },
                    {
                        name: this.$t('reports.cohort-degrees'),
                    },
                ]
            },

            empty() {
                return this.registrations && this.registrations.length == 0
            },
        },

        methods: {

            progress(registration) {
                if (registration.state.sessions_count == 0) {
                    return 0
                }
                let progress = (registration.state.completed_sessions ? registration.state.completed_sessions : 0) * 100 / registration.state.sessions_count
                return parseInt(progress)
            },

            hasData(registration) {
                return registration.state.completed_sessions || registration.state.withdrawed_completed_sessions
            },

            date(date) {
                return this.moment(date).format('YYYY/MM/DD')
            },

            canReadRegistration(registration) {
                return registration.status == 'active'
                    || (registration.status == 'archived' && this.$permissions.hasRight('dashboard.archives.read'))
            },
            
            openRegistration(registration) {
                this.$router.push({
                    name: 'dashboard-cohort-registration',
                    params: {
                        cohortId: this.$route.params.cohortId,
                        registrationId: registration.id
                    }
                })
            },
            
            openResults(registration) {
                this.$router.push({
                    name: 'report-cohort-registration-results',
                    params: {
                        cohortId: this.$route.params.cohortId,
                        registrationId: registration.id
                    }
                })
            },

            openReport(report) {
                this.$router.push({ name: 'report-cohort-' + report, params: { cohortId: this.cohort.id } })
            },
        }
    }
</script>

<style scoped>

    .card >>> td {
        padding: 1.5rem 0 1.5rem 1.5rem;
        font-size: 0.8rem;
    }
    .card >>> td.competencies {
        padding: 0.1rem 0 0.1rem 1.5rem;
    }
    .card >>> td.actions {
        padding-left: 0;
        padding-right: 1.5rem;
    }
    .degrees >>> .progress {
        margin-bottom: 5px;
    }

</style>
